// extracted by mini-css-extract-plugin
export default {"socials":"socials__socials__QWtqo","social":"socials__social__aXsfm","icon":"socials__icon__TsJnt","navOpen":"socials__navOpen__woBFa"};